module.exports = __webpack_public_path__ + "static/logo-67146cf6e423df0d2a76ecfd49de0b5d.png";